// export const baseUrl = "http://192.168.1.182:4000";
//export const baseUrl = "https://nisalondonapi.webdevelopmentsolution.com.au";
//export const baseUrl = "https://backend.nisacosmeticslondon.com";
// export const baseUrl = "https://backend.nisacosmeticslondon.com";



  // currently workking
// export const baseUrl = "http://localhost:81";
export const baseUrl = "https://backend-nisa.demo-developers.com";

      // Before
// export const publishableKey =
//   "pk_live_51NDTYFI7EmYb2dsFBeRG7llA7lxk30tNSWzvDoJ9vfCkh9iTr3kpX7htFoEetdhLgbKG2C6cRkB8o4hVkgQObhJk00MCTlZTBN";



// AFTER
export const publishableKey ="pk_test_51P1liBAWAmSwnqwERa6ITCoZrzwtcTwPVQRA1bS4wVlZphma8CZyqR2Moi3mgg5fiBzLCD1M7Y0ndsIPru38CUej00VQw3PtCm"

